import MathTest from './MathTest';
export default MathTest;